import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { NEWS_COLORS } from "../constants/news.constants";

type NewsTagProps = {
  children: ReactNode;
  className?: string;
};

export function NewsTag({ children, className }: NewsTagProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold text-white",
        className
      )}
      style={{ backgroundColor: NEWS_COLORS.primary }}
    >
      {children}
    </span>
  );
}

type NewsMetaProps = {
  date: string;
  readTime: string;
  className?: string;
};

export function NewsMeta({ date, readTime, className }: NewsMetaProps) {
  return (
    <p className={cn("text-sm text-gray-500", className)}>
      {date}
      <span className="mx-1.5 text-gray-300" aria-hidden>
        •
      </span>
      {readTime}
    </p>
  );
}
